import React from "react";
import FontAwesome from "react-fontawesome";
const RederPermitlist = ({
  lastBookElementRef,
  list,
  snackMessage,
  handleOnClick,
  loading,
  error,
  handleChangeToggle,
}) => {
  // console.log(list)
  return (
    <div className="container-fluid">
      <div>


      {list &&
        list.map((item, index) => {
          if (list.length === index + 1) {
            return (
              <div className="row" key={item.no}>
                <div ref={lastBookElementRef}  className="container-fluid">
                <div className="card border-secondary mt-1">
                    <div
                      className="card-mb-4 bg-info"
                      style={{ height: "14rm", fontSize: "14px" }}
                    >
                      {item.no}
                    </div>
                    <div className="card-body">
                      <div ref={lastBookElementRef} className="row">
                        <div className="container col-xs-12 col-sm-4">

                        <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"ReqID:"} {item.ReqID}
                          </div>
                          <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"Site:"} {item.SiteName}
                          </div>
                        
                                       
                               
                   <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"อาคาร: "}{" "}
                            <span
                              className="badge"
                              style={{ fontSize: "12px" }}
                            >
                             
                           {" "}  {item.LocationName}{" "} 
                            </span>

                           
                          </div>


                        </div>
                        <div className="container col-xs-12 col-sm-4">
                        <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"เจ้าของเครื่อง:"} {item.EmpName}
                          </div>

                         <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"บริษัท: "}{" "}
                            <span
                              className="badge "
                              style={{ fontSize: "12px" }}
                            >
                             
                           {" "}  {item.EmpCompany}
                            </span>

                     
                          </div>
                                          
                          <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"ชื่อเครื่อง: "}{" "}
                            <span
                              className="badge"
                              style={{ fontSize: "12px" }}
                            >
                             
                           {" "}  {item.PCName}{" "} 
                            </span>

                           
                          </div>

                        </div>
                        <div className="container col-xs-12 col-sm-4">
                          <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"OS"}
                            <span
                              className="badge"
                              style={{ fontSize: "14px" }}
                            >
                              {" "}
                              {item.OS}{" "}
                            </span>
                          </div>

                          <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"ตรวจเช็คโดย:"}
                            <span
                              className="badge"
                              style={{ fontSize: "14px" }}
                            >
                              {" "}
                              {item.createname}{" "}
                            </span>
                          </div>
                      
                          <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"Image : "}
                            {item.imagestatus ===1 ? <button
                            className="btn btn-success btn-sm"
                            onClick={() =>
                              handleOnClick(item.ReqID)
                            }
                          >
                           Upload
                          </button>: <button
                            className="btn btn-secondary btn-sm"
                            onClick={() =>
                              handleOnClick(item.ReqID)
                            }
                          >
                           Upload
                          </button>}
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          } else {
            return (
              <div className="row" key={item.no}>
                <div className="container-fluid">
                  <div className="card border-secondary mt-1">
                    <div
                      className="card-mb-4 bg-info"
                      style={{ height: "14rm", fontSize: "14px" }}
                    >
                      {item.no}
                    </div>
                    <div className="card-body">
                      <div ref={lastBookElementRef} className="row">
                        <div className="container col-xs-12 col-sm-4">

                        <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"ReqID:"} {item.ReqID}
                          </div>
                          <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"Site:"} {item.SiteName}
                          </div>
                        
                                       
                               
                   <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"อาคาร: "}{" "}
                            <span
                              className="badge"
                              style={{ fontSize: "12px" }}
                            >
                             
                           {" "}  {item.LocationName}{" "} 
                            </span>

                           
                          </div>


                        </div>
                        <div className="container col-xs-12 col-sm-4">
                        <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"เจ้าของเครื่อง:"} {item.EmpName}
                          </div>

                         <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"บริษัท: "}{" "}
                            <span
                              className="badge "
                              style={{ fontSize: "12px" }}
                            >
                             
                           {" "}  {item.EmpCompany}
                            </span>

                     
                          </div>
                                          
                          <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"ชื่อเครื่อง: "}{" "}
                            <span
                              className="badge"
                              style={{ fontSize: "12px" }}
                            >
                             
                           {" "}  {item.PCName}{" "} 
                            </span>

                           
                          </div>

                        </div>
                        <div className="container col-xs-12 col-sm-4">
                          <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"OS"}
                            <span
                              className="badge"
                              style={{ fontSize: "14px" }}
                            >
                              {" "}
                              {item.OS}{" "}
                            </span>
                          </div>

                          <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"ตรวจเช็คโดย:"}
                            <span
                              className="badge"
                              style={{ fontSize: "14px" }}
                            >
                              {" "}
                              {item.createname}{" "}
                            </span>
                          </div>
                      
                          <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"Image : "}
                            {item.imagestatus ===1 ? <button
                            className="btn btn-success btn-sm"
                            onClick={() =>
                              handleOnClick(item.ReqID)
                            }
                          >
                           Upload
                          </button>: <button
                            className="btn btn-secondary btn-sm"
                            onClick={() =>
                              handleOnClick(item.ReqID)
                            }
                          >
                           Upload
                          </button>}
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        })}
    </div>
     <div>{loading && "Loading..."}</div>
     <div>{error && "Error"}</div>
     <div id="snackbar">{snackMessage}</div>
   </div>
  );
};

export default RederPermitlist;
